import React, { Fragment } from 'react';

import useExpandedRow from '@usas/ui-web/components/grids/UseExpandedRow';

import HideIcon from '@usas/ui-web/components/icons/HideIcon';
import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';

import { formatPhoneNumber } from '@usas/ui-web/utils/validation';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeDetailTableRow = ({ role }) => (
  <tr>
    <td>{role.orgRoleName}</td>
    <td>{formatDate(role.effectiveDate)}</td>
  </tr>
);

const LargeDetailTable = ({ staff }) => (
  <table className={global.DetailTable}>
    <thead>
      <tr>
        <th>Role</th>
        <th>Effective Date</th>
      </tr>
    </thead>
    <tbody>
      {staff.personOrgRole.map((role, i) => <LargeDetailTableRow role={role} key={i} />)}
    </tbody>
  </table>
);

const LargeTableRow = ({ staff, showMemberId, onClick, expandedId }) => (
  <Fragment>
    <tr>
      <td>{staff.firstName} {staff.lastName}</td>
      <td>{formatPhoneNumber(staff.phoneNumber)}</td>
      <td>{staff.email}</td>
      {showMemberId === true &&
        <td>{staff.memberId}</td>
      }
      <td>{staff.isInGoodStanding === true ? 'Yes' : 'No'}</td>
      <td>
        <button
          className={global.IconButtonMargin}
          type="button"
          onClick={(e) => onClick(e, staff.personId)}>
          {expandedId === staff.personId ? <HideIcon /> : <ShowIcon />}
        </button>
      </td>
    </tr>
    {Array.isArray(staff.personOrgRole) && staff.personOrgRole.length > 0 && expandedId === staff.personId &&
      <tr className={global.Expanded}>
        <td colSpan={showMemberId === true ? '6' : '5'}>
          <LargeDetailTable staff={staff} />
        </td>
      </tr>}
  </Fragment>
);

const LargeGrid = ({ state, showMemberId, expandedId, onClick }) => (
  <table className={[global.UsasTable, 'visible-lg  visible-md'].join(' ')}>
    <thead>
      <tr>
        <th>Team Staff Name</th>
        <th>Phone Number</th>
        <th>Email</th>
        {showMemberId === true &&
          <th>Member Id</th>
        }
        <th>Is in good standing?</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {state.isArrayLoaded !== true
        ? (
          <tr>
            {state.isArrayLoading === true
              ? <td colSpan={showMemberId === true ? '6' : '5'}>Loading...</td>
              : <td colSpan={showMemberId === true ? '6' : '5'}>No Staff</td>
            }
          </tr>)
        : Array.isArray(state.arrayData) && state.arrayData.length > 0
          ? state.arrayData.map((staff, i) =>
            <LargeTableRow staff={staff} key={i} showMemberId={showMemberId} expandedId={expandedId} onClick={onClick} />)
          : (
            <tr>
              <td colSpan={showMemberId === true ? '6' : '5'}>No Staff</td>
            </tr>
          )}
    </tbody>
  </table>
);

const SmallDetailTableRow = ({ role }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableDetailRowHead}><span className='hidden-xs'>{role.orgRoleName}</span>&nbsp;
    </div>
    <div className={['row', global.SmallTableRowInfo].join(' ')}>
      <div className={['col-xs-6 visible-xs', global.SmallTableRowLabels].join(' ')}>Role</div>
      <div className={['col-xs-6 visible-xs', global.SmallTableRowData].join(' ')}>{role.orgRoleName}</div>
      <div className={['col-xs-6', global.SmallTableRowLabels].join(' ')}>Effective Date</div>
      <div className={['col-xs-6', global.SmallTableRowData].join(' ')}>{formatDate(role.effectiveDate)}</div>
    </div>
  </div>
);

const SmallDetailTable = ({ staff }) => (
  <div className={global.SmallTableDetailTable}>
    {Array.isArray(staff.personOrgRole) && staff.personOrgRole.map((role, i) => <SmallDetailTableRow key={i} role={role} />)}
  </div>
);

const SmallGridRow = ({ staff, showMemberId, expandedId, onClick }) => (
  <Fragment>
    <div className={global.SmallTableRow}>
      <div className={global.SmallTableRowHead}>
        <span className='hidden-xs'>{staff.firstName} {staff.lastName}</span>&nbsp;
        <button
          className={global.IconButton}
          type="button"
          onClick={(e) => onClick(e, staff.personId)}>
          {expandedId === staff.personId ? <HideIcon /> : <ShowIcon />}
        </button>
      </div>
      <div className={['row', global.SmallTableRowInfo].join(' ')}>
        <div className={['col-xs-6 col-sm-3 visible-xs', global.SmallTableRowLabels].join(' ')}>Staff Name</div>
        <div className={['col-xs-6 col-sm-3 visible-xs', global.SmallTableRowData].join(' ')}>{staff.firstName} {staff.lastName}</div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Phone Number</div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{formatPhoneNumber(staff.phoneNumber) || <span>&nbsp;</span>}</div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Email</div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{staff.email || <span>&nbsp;</span>}</div>
        {showMemberId === true &&
          <Fragment>
            <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Member Id</div>
            <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{staff.memberId || <span>&nbsp;</span>}</div>
          </Fragment>
        }
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Is In Good Standing?</div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{staff.isInGoodStanding === true ? 'Yes' : 'No'}</div>
      </div>
    </div>
    {Array.isArray(staff.personOrgRole) && staff.personOrgRole.length > 0 && expandedId === staff.personId &&
      <SmallDetailTable staff={staff} />}
  </Fragment>
);

const SmallGrid = ({ state, showMemberId, expandedId, onClick }) => (
  <div className={[global.SmallTable, 'hidden-lg hidden-md'].join(' ')}>
    {state.isArrayLoaded !== true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>
            &nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            {state.isArrayLoading === true ?
              <div className={global.SmallTableRowLabels}>Loading...</div>
              : <div className={global.SmallTableRowLabels}>No Staff</div>
            }
          </div>
        </div>
      ) : Array.isArray(state.arrayData) && state.arrayData.length > 0
        ? state.arrayData.map((staff, i) =>
          <SmallGridRow key={i} staff={staff} showMemberId={showMemberId} expandedId={expandedId} onClick={onClick} />) : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>
              &nbsp;
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Staff</div>
            </div>
          </div>
        )
    }
  </div>
);

const TeamStaffReadGrid = ({ state, showMemberId = false }) => {
  const { expandedId, onClick } = useExpandedRow();

  return (
    <Fragment>
      <LargeGrid state={state} showMemberId={showMemberId} expandedId={expandedId} onClick={onClick} />
      <SmallGrid state={state} showMemberId={showMemberId} expandedId={expandedId} onClick={onClick} />
    </Fragment>
  );
};

export default TeamStaffReadGrid;